<input type="file" multiple class="file-input" [accept]="allowedExtensions"
       (change)="onFileChange($event)" #fileUpload>
<div class="file-upload">
  <button *ngIf="files?.length! < 5" class="upload-btn"
          (click)="fileUpload.click()">
    {{ 'common.uploadImage.upload' | transloco }}
  </button>
</div>
<ul *ngIf="files && files.length !== 0" class="list">
  <li *ngFor="let image of files">
    <img [src]="image.url">
    <button (click)="onFileDelete(image._id)">{{ 'common.uploadImage.delete' | transloco }}</button>
  </li>
</ul>
